var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 28,
    viewBox: "0 0 56 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86065 7.67678L4.09848 6.44011L10.8407 13.1799C10.9493 13.2879 11.0356 13.4164 11.0944 13.5578C11.1533 13.6993 11.1836 13.851 11.1836 14.0042C11.1836 14.1574 11.1533 14.3091 11.0944 14.4506C11.0356 14.592 10.9493 14.7204 10.8407 14.8284L4.09848 21.5718L2.86182 20.3351L9.18982 14.0059L2.86065 7.67678Z",
    fill: "#0EA64B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8607 7.67678L25.0985 6.44011L31.8407 13.1799C31.9493 13.2879 32.0356 13.4164 32.0944 13.5578C32.1533 13.6993 32.1836 13.851 32.1836 14.0042C32.1836 14.1574 32.1533 14.3091 32.0944 14.4506C32.0356 14.592 31.9493 14.7204 31.8407 14.8284L25.0985 21.5718L23.8618 20.3351L30.1898 14.0059L23.8607 7.67678Z",
    fill: "#0EA64B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8607 7.67678L46.0985 6.44011L52.8407 13.1799C52.9493 13.2879 53.0356 13.4164 53.0944 13.5578C53.1533 13.6993 53.1836 13.851 53.1836 14.0042C53.1836 14.1574 53.1533 14.3091 53.0944 14.4506C53.0356 14.592 52.9493 14.7204 52.8407 14.8284L46.0985 21.5718L44.8618 20.3351L51.1898 14.0059L44.8607 7.67678Z",
    fill: "#0EA64B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepGreen);
export default __webpack_public_path__ + "static/media/step-green.d6e1ae0ffcda08aa9dbcd23a7137c41a.svg";
export { ForwardRef as ReactComponent };